import { services } from "../../data/content";
import useReveal from "../../hooks/useReveal";
import SectionTitle from "../ui/SectionTitle";

function ServiceCard({ service, delay }) {
  const ref = useReveal();

  return (
    <article
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className="reveal group overflow-hidden rounded-2xl bg-surface-raised shadow-lg shadow-black/30 transition-transform duration-300 hover:-translate-y-2"
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          loading="lazy"
          width={800}
          height={600}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-6">
        <h3 className="mb-3 font-display text-xl font-bold uppercase text-white">{service.title}</h3>
        <p className="text-sm leading-relaxed text-stone-400">{service.text}</p>
      </div>
    </article>
  );
}

export default function Services() {
  return (
    <section id="services" className="scroll-mt-20 bg-ink py-20 sm:py-28">
      <div className="container">
        <SectionTitle
          align="center"
          eyebrow="Nos prestations"
          title="Comment nous faisons vibrer vos événements"
          className="mx-auto max-w-2xl"
        />

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => (
            <ServiceCard key={service.title} service={service} delay={i * 120} />
          ))}
        </div>
      </div>
    </section>
  );
}
